import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  premium: {
    basePremium: 0,
    tax: 0,
    totalPremium: 0,
    isCalculated: false
  },
  quoteData: null,
  isLoadingQuote: false,
  quoteError: null
};

const domesticHelperFormSlice = createSlice({
  name: 'domesticHelperForm',
  initialState,
  reducers: {
    saveDomesticHelperFormData: (state, action) => {
      const { formName, data } = action.payload;
      state[formName] = data;
    },
    clearDomesticHelperFormData: (state, action) => {
      const { formName } = action.payload;
      if (formName) {
        delete state[formName];
      } else {
        return initialState;
      }
    },
    updateDomesticHelperPremium: (state, action) => {
      const { basePremium, tax, totalPremium } = action.payload;
      state.premium = {
        basePremium,
        tax,
        totalPremium,
        isCalculated: true
      };
    },
    setQuoteLoading: (state, action) => {
      state.isLoadingQuote = action.payload;
    },
    setQuoteData: (state, action) => {
      state.quoteData = action.payload;
      state.isLoadingQuote = false;
      state.quoteError = null;

      // Update premium from API response
      if (action.payload) {
        state.premium = {
          basePremium: parseFloat(action.payload.premium || 0),
          tax: parseFloat(action.payload.tax || 0),
          totalPremium: parseFloat(action.payload.totalPremium || 0),
          isCalculated: true
        };
      }
    },
    setQuoteError: (state, action) => {
      state.quoteError = action.payload;
      state.isLoadingQuote = false;
    },
    clearQuoteData: (state) => {
      state.quoteData = null;
      state.quoteError = null;
      state.isLoadingQuote = false;
    }
  },
});

export const {
  saveDomesticHelperFormData,
  clearDomesticHelperFormData,
  updateDomesticHelperPremium,
  setQuoteLoading,
  setQuoteData,
  setQuoteError,
  clearQuoteData
} = domesticHelperFormSlice.actions;

export const selectDomesticHelperFormData = (state) => state.domesticHelperForm || {};
export const selectDomesticHelperPremium = (state) => state.domesticHelperForm?.premium || { basePremium: 0, tax: 0, totalPremium: 0, isCalculated: false };
export const selectDomesticHelperQuoteData = (state) => state.domesticHelperForm?.quoteData || null;
export const selectDomesticHelperQuoteLoading = (state) => state.domesticHelperForm?.isLoadingQuote || false;
export const selectDomesticHelperQuoteError = (state) => state.domesticHelperForm?.quoteError || null;

export default domesticHelperFormSlice.reducer;
